import { render } from "./ClicksReport.vue?vue&type=template&id=26c18fbe&scoped=true"
import script from "./ClicksReport.vue?vue&type=script&lang=js"
export * from "./ClicksReport.vue?vue&type=script&lang=js"

import "./ClicksReport.vue?vue&type=style&index=0&id=26c18fbe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c18fbe"]])

export default __exports__